// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e6c63149","405":"67f3bf61","476":"67e573b7","484":"1bf2abf2","488":"4c6a5943","580":"251822ac","686":"6b923bf4","753":"52dfb848"}[chunkId] + ".chunk.js";
};